<template>
    <section class="c-component-why-quarkino">
        <y-loading
            v-if="!componentContent"
            :active="$wait.is('loading-component-section')"
            size="60"
            height="467px"
            position="relative"
        />
        <div
            v-else
            class="c-component-why-quarkino--loaded"
        >
            <div v-if="isDesktop">
                <h2 class="c-component-why-quarkino__title">
                    {{ componentContent.title }}
                </h2>
                <p class="c-component-why-quarkino__description">
                    {{ componentContent.title2 }}
                </p>
            </div>
            <div class="c-component-why-quarkino__wrapper">
                <div class="c-component-why-quarkino__quark-image">
                    <img
                        :src="componentContent.image.link"
                        alt=" "
                    >
                    <span
                        v-for="(components,index) in componentContent.albums"
                        :key="components.id"
                        class="components-title"
                        :class="{'selected-component' : current === index}"
                        @click="setCurrent(index)"
                    >{{ components.title }}</span>
                </div>
                <div class="c-component-why-quarkino__text-slider">
                    <h2
                        v-if="!isDesktop"
                        class="c-component-why-quarkino__title"
                    >
                        {{ componentContent.title }}
                    </h2>
                    <p
                        v-if="!isDesktop"
                        class="c-component-why-quarkino__description"
                    >
                        {{ componentContent.title2 }}
                    </p>
                    
                    <div class="c-component-why-quarkino__card">
                        <y-owl-slide-show
                            ref="owlSlideShow"
                            :items="1"
                            :margin="7"
                            dots
                            loop
                            auto-height
                            autoplay-hover-pause
                            autoplay
                            :item-index="sliderIndex"
                            @changed-index="getNewIndex"
                        >
                            <div
                                v-for="components in componentContent.albums"
                                :key="components.id"
                                class="c-component-why-quarkino__card-content pa-3 pt-6 pb-6"
                                :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                            >
                                <h3>
                                    {{ `${components.title}, ` }}
                                </h3>
                                <span>{{ components.hyperlink }}</span>
                                <p>
                                    {{ components.description }}
                                </p>
                            </div>
                        </y-owl-slide-show>
                    </div>
                </div>
            </div>
            <div
                v-if="componentContent.custom"
                class="c-component-why-quarkino__action"
            >
                <y-button
                    color="primary"
                    :tag="isLink(componentContent.custom['button-link']) ? 'a' : 'router-link'"
                    :to="componentContent.custom['button-link']"
                    :href="componentContent.custom['button-link']"
                >
                    {{ componentContent.custom['button-title'] }}
                </y-button>
            </div>
        </div>
    </section>
</template>

<script >
    import YOwlSlideShow from '@components/OwlSlideShow/Index';
    import { isLink } from '@/helpers/helpers';

    export default {
        name: 'WhyQuarkinoComponents',

        components: {
            YOwlSlideShow,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                componentContent: null,
                current         : '',
                sliderIndex     : 1,
            };
        },

        computed: {
            /**
             *
             * Whether the device is desktop or not
             *
             * @returns {boolean}
             */
            isDesktop() {
                if (this.$mq === 'xlg' ) {
                    return 0;
                }

                return 1;
            },
        },

        /**
         * @inheritDoc
         */
        created() {
            this.fetch();
        },

        /**
         * @inheritDoc
         */
        methods: {
            isLink,

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-component-section');
                const features = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'why-quarkino-components',
                    including: ['title', 'custom', 'albums', 'title2', 'image'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([features])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.componentContent = responses[0].data.results;
                            this.current = 0;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-component-section');
                    });
            },

            /**
             * set the Id of selected item
             *
             * @param {string} index
             */
            setCurrent(index) {
                this.current = index;
                this.sliderIndex = index + 1;
            },

            /**
             * get new index
             *
             * @param {string} value
             */
            getNewIndex(value) {
                this.current = value;
            },
        },
    };

</script>

<style lang="scss" src="./quarkino-component.scss"/>
